module.exports = __webpack_public_path__ + "static/media/money-check-alt.1d354d73.svg";